module.exports = __webpack_public_path__ + "02_veryshort_gray.2193ee07.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/02_veryshort_gray.png
// module id = P5WR
// module chunks = 0